import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import CryptoJS from 'crypto-js';

// aes-cbc模式加密
var KEY = 'm.zhuanzhuan.com'; //  密钥    长度为16位
var IV = 'zhuanzhuan-lease'; //  初始偏移量   长度随意

/**
 * 加密数据
 * @param { Object } data 要加密的数据
 * @param { String } key 密钥
 * @param { String } iv 偏移量
 * @param { Boolean } isNeedBase64 默认true，是否需要返回 base64
 */
var encrypt = function encrypt(_ref) {
  var data = _ref.data,
    _ref$isNeedBase = _ref.isNeedBase64,
    isNeedBase64 = _ref$isNeedBase === void 0 ? true : _ref$isNeedBase,
    _ref$key = _ref.key,
    key = _ref$key === void 0 ? KEY : _ref$key,
    _ref$iv = _ref.iv,
    iv = _ref$iv === void 0 ? IV : _ref$iv;
  var _key = CryptoJS.enc.Utf8.parse(key);
  var _iv = CryptoJS.enc.Utf8.parse(iv);
  var isObject = Object.prototype.toString.call(data) == '[object Object]';
  var _data = isObject ? CryptoJS.enc.Utf8.parse(JSON.stringify(data)) : CryptoJS.enc.Utf8.parse(data);
  var encrypted = CryptoJS.AES.encrypt(_data, _key, {
    iv: _iv,
    mode: CryptoJS.mode.CBC,
    // 加密模式
    padding: CryptoJS.pad.Pkcs7
  });
  var encryptedValue = isNeedBase64 ? CryptoJS.enc.Base64.stringify(encrypted.ciphertext) : encrypted.ciphertext.toString();
  return encryptedValue;
};

/**
 * 解密数据
 * @param { Object } data 要解密的数据
 * @param { String } key 密钥
 * @param { String } iv 偏移量
 */
var decrypt = function decrypt(_ref2) {
  var data = _ref2.data,
    _ref2$key = _ref2.key,
    key = _ref2$key === void 0 ? KEY : _ref2$key,
    _ref2$iv = _ref2.iv,
    iv = _ref2$iv === void 0 ? IV : _ref2$iv;
  var _key = CryptoJS.enc.Utf8.parse(key);
  var _iv = CryptoJS.enc.Utf8.parse(iv);
  var _data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Base64.parse(data.replace(/\s+/g, '')));
  var decrypted = CryptoJS.AES.decrypt(_data, _key, {
    iv: _iv,
    mode: CryptoJS.mode.CBC,
    // 加密模式
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptedValue = decrypted.toString(CryptoJS.enc.Utf8).toString();
  return decryptedValue;
};
export default {
  encrypt: encrypt,
  decrypt: decrypt
};